import Blank from "@/layouts/blank.vue";
import EmergencyOrderContainerList from "@/pages/admin/emergency-order-container/EmergencyOrderContainerList.vue";
import EmergencyOrderContainerDetails from "@/pages/admin/emergency-order-container/EmergencyOrderContainerDetails.vue";

const emergencyOrderContainerRoutes = [
  {
    path: "emergency-order-container",
    name: "app-admin-emergency-order-container",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/emergency-order-container/list",
      },
      {
        path: "list",
        name: "app-admin-emergency-order-container-list",
        component: EmergencyOrderContainerList,
      },
      {
        path: "details/:id",
        name: "app-admin-emergency-order-container-details",
        component: EmergencyOrderContainerDetails,
      },
    ],
  },
];

export default emergencyOrderContainerRoutes;
